import { Injectable } from '@angular/core';

@Injectable()
export class CounterSharedService {
  private counterInstances: any = {};

  generateUniqueKey() {
    const randomKey = new Date().valueOf() + Math.random() * 1000;
    if (this.getInstance(randomKey)) {
      this.generateUniqueKey();
    } else {
      return randomKey;
    }
  }
  setInstance(instance, key) {
    this.counterInstances[key] = instance;
  }
  getInstance(key) {
    return this.counterInstances[key];
  }
  loadCounterValue(counter, key) {
    if (this.counterInstances[key]) {
      this.counterInstances[key].counterValue = counter;
    }
  }

  changePosition(el) {
  setTimeout(() => {
    const counterValue = el.nativeElement.parentElement.getElementsByTagName('conter-value')[0];
    const clearValue = el.nativeElement.parentElement.getElementsByTagName('axis-clear-input')[0];
    if (clearValue) {
       el.nativeElement.parentElement.insertBefore(clearValue, counterValue);
    }
  })
  }
  destroyInstance(key) {
    delete this.counterInstances[key];
  }
}
